import { Operation } from 'shell/view-models/operation';
import { Order } from 'shell/view-models/order';
import { paginationListToQueryString } from 'system/utils/list-object-to-query-string';
import { OperationObject } from 'system/utils/operation-object-to-query-string';
import { AxiosResponse } from 'axios';
import { HttpResponseList } from 'shell/models/http-response';
import { Pec, PecComunicazioneVO } from 'shell/models/pec';
import { DateTime } from 'luxon';
import { Chip, Typography } from '@mui/material';
import { ReactElement } from 'react';
import { ChipPropsColorOverrides } from '@mui/material';
import { OverridableStringUnion } from '@mui/types';
import { FiltersFormPec, PecClient } from 'shell/types/types-pec';

type PecStateColor = OverridableStringUnion<
  'default' | 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning',
  ChipPropsColorOverrides
>;

export type PecState = {
  color: PecStateColor;
  label?: string;
};

export enum PecStateEnum {
  Sentable = '1',
  Suspended = '2',
  Error = '3',
  Delivered = '7',
  Canceled = '8',
  FailureDeliver = '6',
  Sent = '4',
  Accepted = '5',
}

export const formatStatePecObject = (state?: PecStateEnum, description?: string): PecState => {
  let color: PecStateColor = 'primary';

  const label = description;

  // Stato uguale a inviata
  if (state === PecStateEnum.Sent) {
    color = 'cdmBrandYellow';
  }

  if (state === PecStateEnum.Error) {
    color = 'cdmBrand';
  }

  // Stato uguale ad accettata
  if (state === PecStateEnum.Accepted) {
    color = 'cdmBrandOrange';
  }
  // Stato uguale a consegnata
  if (state === PecStateEnum.Delivered) {
    color = 'cdmBrandSecondary';
  }

  return { color, label };
};

const formatStatePec = (state?: PecStateEnum, description?: string): ReactElement => {
  const result = formatStatePecObject(state, description);
  return <Chip color={result.color} label={result.label || ''}></Chip>;
};

export const transformResponseListPec = (
  response: AxiosResponse<HttpResponseList<Pec> | PecComunicazioneVO>
): Array<PecClient> => {
  return (
    (response.data as HttpResponseList<Pec>).payload?.list ||
    (response.data as PecComunicazioneVO)?.pecComunicazioneVOList
  )?.map(
    (item) =>
      ({
        code: item.key?.idComunicazione,
        dateHour: item.timestampInvio
          ? DateTime.fromISO(item.timestampInvio).toFormat('dd/MM/yyyy - HH:mm')
          : '',
        typeComunication: item.codComunicazione,
        message: (
          <Typography
            sx={{
              textOverflow: 'ellipsis',
              overflow: 'hidden',
            }}
          >
            {item.corpo}
          </Typography>
        ),
        object: item.oggetto || '',
        // sent: item.pecDestinatarioVOList
        //   ? item.pecDestinatarioVOList.map((el) => (
        //       <Typography
        //         sx={{
        //           // textOverflow: 'ellipsis',
        //           // overflow: 'hidden',
        //           wordBreak: 'break-all',
        //         }}
        //         key={el.key.idComunicazione}
        //       >
        //         {el.key.destinatario}
        //       </Typography>
        //     ))
        //   : undefined,
        sent: (item.pecDestinatarioVOList || [])
          .map((itemDestinatario) => itemDestinatario.descrizioneDestinatario || '')
          .join(', '),
        data: item.timestampInserimento
          ? DateTime.fromISO(item.timestampInserimento).toFormat('dd/MM/yyyy - HH:mm')
          : '',
        state: formatStatePec(item.codiceStato, item.descrizioneStato),
      } as PecClient)
  );
};

export const transformDataset = (values: FiltersFormPec): string => {
  const { ...otherValues } = values;

  const transformedFilters: OperationObject = {
    mittente: {
      value: otherValues.emailSender || '',
      operation: Operation.LIKE,
    },
    codComunicazione: {
      value: otherValues.typeComunication || '',
      operation: Operation.EQUALS,
    },
    destinatario: {
      value: otherValues.emailReceiver || '',
      operation: Operation.LIKE,
    },
    descrizioneDestinatario: {
      value: otherValues.descriptionReceiver || '',
      operation: Operation.LIKE,
    },
    corpo: {
      value: otherValues.message || '',
      operation: Operation.LIKE,
    },
    codiceStato: { value: otherValues.state || '', operation: Operation.EQUALS },
    timestampInserimentoDa: {
      value: otherValues.startDate?.toFormat('yyyy-MM-dd') || '',
      operation: Operation.EQUALS,
    },
    timestampInserimentoA: {
      value: otherValues.endDate?.toFormat('yyyy-MM-dd') || '',
      operation: Operation.EQUALS,
    },
    codiceOperatoreInserimento: {
      value: otherValues?.codOperator || '',
      operation: Operation.EQUALS,
    },
  };

  const ordersMapped: Order = {};

  return `${paginationListToQueryString({
    filters: transformedFilters,
    orders: ordersMapped,
  })}`;
};
